import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  dropArea: {
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    border: "1px dashed ".concat(palette.shades[600]),
    borderRadius: '2px',
    transition: '0.2s',
    minHeight: '71px',
    fontSize: '17px',
    padding: '12px',
    textAlign: 'center',
    backgroundColor: "".concat(palette.shades[100]),
    '&:not(.active):hover': {
      backgroundColor: "".concat(palette.shades[200])
    },
    '&:not(.active).drag': {
      backgroundColor: "".concat(palette.shades[200])
    },
    '&.active': {
      textAlign: 'left',
      border: "1px solid ".concat(palette.shades[300]),
      '& input': {
        width: '1px',
        height: '1px'
      }
    },
    '& span': {
      color: palette.primary.main
    },
    '& input': {
      top: '0',
      left: '0',
      opacity: '0',
      width: '100%',
      height: '100%',
      position: 'absolute',
      cursor: 'pointer',
      padding: '0',
      '&:focus': {
        outline: 'none'
      }
    },
    '&.disabled': {
      backgroundColor: "".concat(palette.shades[200]),
      opacity: '0.5',
      '& input': {
        cursor: 'auto'
      }
    }
  },
  preview: {
    width: '44px',
    height: '44px',
    display: 'flex',
    flexShrink: '0',
    cursor: 'pointer',
    marginRight: '12px',
    borderRadius: '2px',
    alignItems: 'center',
    justifyContent: 'center',
    border: "1px solid ".concat(palette.shades[300])
  },
  fileInfo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '&.center': {
      justifyContent: 'center'
    }
  },
  previewBill: {
    marginLeft: '12px',
    '& .MuiSvgIcon-root': {
      marginRight: '4px'
    },
    '& span': {
      color: palette.common.black
    }
  }
});
export default useStyles;